fp.ui.validation = {
	rules: {
		required: {
			message: function() {
				return fp.ui.locale('shared-required', '{0} is required.');
			}
		},
		email: {
			message: function() {
				return fp.ui.locale('shared-valid-email', '{0} must be a valid email address.');
			},
			match: /^((([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))(\s*;\s*|\s*$))*$/
		},
        "postal-code": {
            message: function() {
				return fp.ui.locale('shared-valid-postal-code', '{0} must be a valid postal code.');
			},
            match: /^\d{5}(?:[-\s]?\d{4})?$/
        },
        phone: {
            message: function() {
				return fp.ui.locale('shared-valid-phone-number', '{0} must be a valid phone number.');
			},
            match: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
        },
		numeric: {
			message: function() {
				return fp.ui.locale('shared-valid-number', '{0} must be a valid number.');
			},
			match: /^-?\d*(\.\d+)?$/
		},
		integer: {
			message: function() {
				return fp.ui.locale('shared-valid-number', '{0} must be a valid number.');
			},
			match: /^-?\d+$/
		},
		"integer-positive": {
			message: function() {
				return fp.ui.locale('shared-valid-number', '{0} must be a valid number.');
			},
			match: /^\d+$/
		},
		"min-length": {
			message: function() {
				return fp.ui.locale('shared-valid-length', '{0} must have at least {1} character(s).');
			}
		},
		"credit-card": {
			message: function() {
				return fp.ui.locale('shared-valid-credit-card', '{0} must be a valid credit card.');
			}
		},
		"min-date": {
			message: function() {
				return fp.ui.locale('shared-valid-date', '{0} must be greater than current date.');
			}
		},
		compare: {
			message: function() {
				return fp.ui.locale('shared-valid-comparison', '{0} must be {1} {2}.');
			}
		},
		xss: {
			message: function() {
				return fp.ui.locale('shared-valid-value', '{0} contains invalid characters.');
			},
			match: fpUtil.regExp.matchFormXssInvalidChars,
            negate: true
		}
	}
};
